import { z } from 'zod';

export const KeywordIdSchema = z.number();
export type KeywordId = z.infer<typeof KeywordIdSchema>;
